import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App,PopoverController, IonicPage } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { PrimaryContactModal } from './component/primary-applicant/primary-form/primary.model';
import { PrimaryGoalModal } from './component/primary-applicant/primary-goal/primary-goal.model';
import { AddressDetailModal } from './component/primary-applicant/address-detail/address-detail.model';
import { EnvDataService } from '../../app/services/env-data-service';
import { SdfFormService } from '../../app/services/sdf-form-service';
import { DataService } from './services/data.service';
import { PrimaryForm } from './component/primary-applicant/primary-form/primary';
import { AdditionalContact } from './component/primary-applicant/additional-contact/additional-contact';
import { DependentDetails } from './component/dependent-and-family/dependent-details/dependent-details';
import { EmploymentDetails } from './component/employment-and-incomedetails/employment-details/employment_details';
import { IncomeDetails } from './component/employment-and-incomedetails/income-details/income_details';
import { ADFFormService } from './services/adf-form.service';
import { AddressDetail } from './component/primary-applicant/address-detail/address-detail';
import {PrimaryGoal} from '../../pages/adf-page/component/primary-applicant/primary-goal/primary-goal'
import {AssetsForm} from '../adf-page/component/assets-and-liablities/assets/assets';
import {LiablitiesForm} from '../adf-page/component/assets-and-liablities/liablities/liablities';
import {RealEstateAssets} from '../adf-page/component/real-estate-assets/real-estate-assets';
import { ViewAdfPage } from '../view-adf/view-adf';
import { LoadingProvider } from '../../providers/loading/loading';
import {AdfList} from '../adf-list/adf-list';
import { AngularFireDatabaseModule } from 'angularfire2/database';
//import { AdfStatusChangePage } from '../adf-status-change/adf-status-change';

import {ShowContactForm} from '../show-contact/show-contact';
import { AdfCustomerExistPage } from '../adf-customer-exist/adf-customer-exist';

declare var google;

@IonicPage({
  name: 'AdfPage',
  segment: 'adf-page',
  // defaultHistory: ['LoginPage'],
  priority: 'high'
})

@Component({
  selector: 'adf-page',
  templateUrl: 'adf-page.html',
  providers: [EnvDataService, DataService, ADFFormService]
})
export class AdfPage {
  @ViewChild(PrimaryForm) PrimaryForm: PrimaryForm;
  @ViewChild(AdditionalContact) AdditionalContact: AdditionalContact;
  @ViewChild(DependentDetails) DependentDetails: DependentDetails;
  @ViewChild(AddressDetail) AddressDetail: AddressDetail;
  @ViewChild(EmploymentDetails) EmploymentDetails: EmploymentDetails;
  @ViewChild(IncomeDetails) IncomeDetails: IncomeDetails;
  @ViewChild(AddressDetail) AddressDetails: AddressDetail;
  @ViewChild(PrimaryGoal) PrimaryGoal:PrimaryGoal;
  @ViewChild(AssetsForm) AssetsForm:AssetsForm;
  @ViewChild(LiablitiesForm) LiablitiesForm:LiablitiesForm;
  @ViewChild(RealEstateAssets) RealEstateAssets:RealEstateAssets;

  SDF_form_document_id: any;
  primary_uid: any;
  userRole: any;
  deleted_access: any;
  primary_Contact_load = false;
  additional_Contact_load = false;
  public primaryContact: any;
  public primaryformget: any;
  public dependentformget:any;
  public employmentformget:any;
  public incomeformget:any;
  public additionalContact: any;
  public primaryGoal: PrimaryGoalModal = new PrimaryGoalModal();

  addressFormValue:any;
  primaryGoalFormValue:any;
  assetsFormValue:any;
  liabilityFormValue;
  realEstateFormValue;
  isValidPrimaryForm:boolean=false;
  isValidPrimaryGoalForm:boolean=false;
  isValidAddressForm:boolean=false;
  isValidDependentDetialsForm:boolean;
  isValidEmplomentDeatilForm:boolean;
  adfModuleAllFormData:any={};
  public primary_contact_id:any;
  adfFormAllIdForSubmit:any;
  realEstateFormIsValid:boolean;
  dateCommence:any;

  primary_form:FormGroup;
  address_detail_form:FormGroup;
  primary_goal_form:FormGroup;
  dependent_detail_form:FormGroup;
  employment_details:FormGroup;
  income_details_form:FormGroup;
  assert_form:FormGroup;
  liability_form:FormGroup;
  realestate_form:FormGroup;

  isValidPercentage:boolean=true;
  contact_page:boolean = false;
  checkBalanceBool:boolean;

  public itemList =
    [
      { name: '1 Primary Applicant Details' },
      { name: '2 Dependents and Family' },
      { name: '3 Your Employment and Income Details' },
      { name: '4 Assets and Liabilities' },
      { name: '5 Real Estate Assets' },
    ];

  primaryApplicantDetails: boolean = true;
  primaryApplicantDetailsIcon = 'close-circle';
  dependentAndFamily: boolean = true;
  dependentAndFamilyIcon = 'close-circle';
  employmentAndIncomeDetails: boolean = true;
  employmentAndIncomeDetailsIcon = 'close-circle';
  incomeDetails: boolean = true;
  incomeDetailsIcon = 'close-circle';
  assetsAndLiablities: boolean = false;
  assetsAndLiablitiesIcon = 'close-circle';
  realEstate: boolean = false;
  realEstateIcon = 'close-circle';
  public indexx: number;
  public secondary_uid: any;
  edit_user_id:any;
  edit_form_id:any;
  edit_flag:any;
  adfFormStatus:boolean = false;
  public contact_email: any;
  step1FormStatus:boolean = false;
  step2FormStatus:boolean = false;
  step3FormStatus:boolean = false;
  step4FormStatus:boolean = false;
  step5FormStatus:boolean = false;
  step6FormStatus:boolean = false;
  step1FormStatusInvalid:boolean = false;
  step2FormStatusInvalid:boolean = false;
  step3FormStatusInvalid:boolean = false;
  step4FormStatusInvalid:boolean = false;
  step5FormStatusInvalid:boolean = false;
  step6FormStatusInvalid:boolean = false;

  constructor(
    public db: AngularFirestore,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private ADFFormService: ADFFormService,
    private DataService: DataService,
    public SdfFormService: SdfFormService,
    public toastCtrl: ToastController,
    public navCtrl: NavController,
    public loadingProvider: LoadingProvider,
    public popoverCtrl: PopoverController,
    public modalCtrl : ModalController
  ) {
    this.secondary_uid = [];
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    this.contact_email = this.navParams.get("contact_email");
    this.contact_page = this.navParams.get("contact_page");

    if(this.contact_email) {

      this.loadApplicantData(this.contact_email);

    }

    console.log(this.contact_email);
    debugger;
    let thiss = this;

    this.edit_user_id=this.navParams.get('user_id');
    this.edit_form_id=this.navParams.get('form_id');
    this.edit_flag=this.navParams.get('edit_flag');
    console.log(this.edit_user_id, this.edit_form_id, this.edit_flag);
    
    this.userRole = window.localStorage.getItem("userRole");

    if(this.edit_flag != '' && this.edit_flag === 'edit'){

      console.log(this.edit_form_id);
      debugger;
      this.ADFFormService.getspecificApplicationsById(this.edit_form_id)
      .then(data=>{
        debugger;
        let modeOfOpeartion:{
          adfFormEditing:"yes"
        }
        let modeOfOperationEdit= 'yes';
        console.log(data);

        if(data[0].application_status !== 'closed') {
          this.adfFormStatus = true;
        }

        if(data[0].assets) {
          this.AssetsForm.populateDataForEdit(data[0].assets);
        }

        this.LiablitiesForm.populateDataForEdit(data[0].liabilities);
        this.RealEstateAssets.populateDataForEdit(data[0].realestate,data[0].contacts);

        this.PrimaryForm.populateDataForEdit(data[0].contacts,data[0].reference_broker,data,modeOfOperationEdit);
        this.AddressDetail.populateDataForEdit(data[0].contacts);
        this.PrimaryGoal.populateDataForEdit(data[0].primayr_goal_intention);
        this.DependentDetails.populateDataForEdit(data[0].contacts);
        this.EmploymentDetails.populateDataForEdit(data[0].contacts,modeOfOperationEdit);

        this.IncomeDetails.populateDataForEdit(data[0].contacts,data[0]);

         this.checkvalidslide();

        // if(this.PrimaryForm.primaryForm.valid && this.PrimaryGoal.primaryGoal.valid && this.AddressDetail.addreDetail.valid)
        // {
        //   this.step1FormStatus = true;
        //   this.primaryApplicantDetailsIcon = 'checkmark';

        // }
        // if(this.DependentDetails.slideTwoForm.valid)
        // {
        //   this.step2FormStatus = true;
        //   this.dependentAndFamilyIcon = 'checkmark';

        // }
        // if(this.EmploymentDetails.slideThreeForm.valid)
        // {
        //   this.step3FormStatus = true;
        //   this.employmentAndIncomeDetailsIcon = 'checkmark';

        // }
        // if(this.IncomeDetails.incomeForm.valid)
        // {
        //   this.step4FormStatus = true;
        //   this.incomeDetailsIcon = 'checkmark';

        // }
        // if(this.AssetsForm.assetsForm.valid && this.LiablitiesForm.liabilitiesForm.valid)
        // {
        //   this.step5FormStatus = true;
        //   this.assetsAndLiablitiesIcon = 'checkmark';

        // }
        // if(this.RealEstateAssets.realEstateForm.valid)
        // {
        //   this.step6FormStatus = true;
        //   this.realEstateIcon = 'checkmark';

        // }

      })
      .catch(error=>{

      })
    }


  }

  ngOnInit() {
    debugger;
    var first = document.getElementById("primaryApplicantDetails");
    first.style.display = "block";
    var second = document.getElementById("dependentAndFamily");
    second.style.display = "none";
    var third = document.getElementById("employmentAndIncomeDetails");
    third.style.display = "none";
    var forth = document.getElementById("IncomeDetails");
    forth.style.display = "none";
    var fifth = document.getElementById("assetsAndLiablities");
    fifth.style.display = "none";
    var sixth = document.getElementById("realEstate");
    sixth.style.display = "none";
    this.primaryApplicantDetailsIcon = 'checkmark';

    let limit =20;
    let offset = 1;

  }


  submit() {

    this.PrimaryForm.addAnotherApplicant();
    this.AdditionalContact.addAnotherApplicant();
    this.DependentDetails.addAnotherApplicant();
    this.EmploymentDetails.addAnotherApplicant();
    this.IncomeDetails.addAnotherApplicant();
    this.AssetsForm.addAnotherApplicant();

  }

  getUserData(e) {

    debugger;
    console.log(e);
    if(e.status == 'error') {
      // this.AddressDetails.addreDetail.reset();
      // this.DependentDetails.slideTwoForm.reset();
      // this.EmploymentDetails.slideThreeForm.reset();
      // this.AssetsForm.assetsForm.reset();
    }
    else {
      //let address_form_value = this.AddressDetails.addreDetail.value;

      this.primary_contact_id = e.user_data.uid;
      this.AddressDetails.getUserData(e);
      this.DependentDetails.getUserData(e);
      this.EmploymentDetails.getUserData(e);
      this.IncomeDetails.getUserData(e);
      this.AssetsForm.getUserData(e);
      this.RealEstateAssets.getUserData(e);
      //this.RealEstateAssets.setrealEstateForm(this.primaryformget,address_form_value);
    }

  }

  loadApplicantData(contact_email) {

    this.loadingProvider.startLoading();
    this.ADFFormService.getApplicantDetailsByEmail(contact_email)
    .then((data:any)=>{

      console.log(data);

      debugger;
      //let address_form_value = this.AddressDetails.addreDetail.value;
      this.PrimaryForm.getUserData(data);
      this.AddressDetails.getUserData(data);
      this.DependentDetails.getUserData(data);
      this.EmploymentDetails.getUserData(data);
      this.IncomeDetails.getUserData(data);
      this.AssetsForm.getUserData(data);
      this.RealEstateAssets.getUserData(data);
      this.loadingProvider.stopLoading();
      if(data) {
        console.log('contact data',data);
        
        this.presentToast('contact found.');
      }


    }).catch(error=>{

      console.log(contact_email);
      this.loadingProvider.stopLoading();
      this.presentToast('contact data is not exist.');
      // this.primaryForm.controls.firstname.setValue('');
      // this.primaryForm.controls.middlename.setValue('');
      // this.primaryForm.controls.lastname.setValue('');
      // this.primaryForm.controls.email.setValue(user_email);
      // this.primaryForm.controls.mobile_phone.setValue('');
      // this.primaryForm.controls.date_of_birth.setValue('');
      // this.primaryForm.controls.email.setValue('');
      let data = {
        status:'error',
        message:'not_found'
      }
     // this.userdata_evntemit.emit(data);

    })

  }

  checkcustomer() {
    //var data = { message : 'hello world' };
    let thiss = this;
    let editMenu = this.popoverCtrl.create(AdfCustomerExistPage, { showBackdrop: true, cssClass: 'popOverClass' });
    editMenu.present({
      ev: event
    });

    editMenu.onDidDismiss((data) => {
      //alert('working');
      if(data) {
        let user_email = data.user_email;
        thiss.loadApplicantData(user_email);
      }


    })
  }

  getAnotherApplicantUserData(e) {

    this.AddressDetails.getAdditionalApplicantUserData(e.userdata, e.index);
    this.DependentDetails.getAdditionalApplicantUserData1(e.userdata, e.index);
    this.EmploymentDetails.getAdditionalApplicantUserData(e.userdata, e.index);
  }

  slideNum(event) {

    if (event == 'first') {
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "block";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "none";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "none";
      var forth = document.getElementById("IncomeDetails");
      forth.style.display = "none";
      var fifth = document.getElementById("assetsAndLiablities");
      fifth.style.display = "none";
      var sixth = document.getElementById("realEstate");
      sixth.style.display = "none";

      // if(this.step1FormStatus) {
      //   this.primaryApplicantDetailsIcon = 'checkmark';
      //  }
      //  else {
      //   this.primaryApplicantDetailsIcon = 'close-circle';
      //  }
      this.primaryApplicantDetailsIcon = 'checkmark';
      this.dependentAndFamilyIcon = 'close-circle';
      this.employmentAndIncomeDetailsIcon = 'close-circle';
      this.incomeDetailsIcon = 'close-circle';
      this.assetsAndLiablitiesIcon = 'close-circle';
      this.realEstateIcon = 'close-circle';
    } else if (event == 'second') {
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "block";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "none";
      var forth = document.getElementById("IncomeDetails");
      forth.style.display = "none";
      var fifth = document.getElementById("assetsAndLiablities");
      fifth.style.display = "none";
      var sixth = document.getElementById("realEstate");
      sixth.style.display = "none";
      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'checkmark';
      this.employmentAndIncomeDetailsIcon = 'close-circle';
      this.incomeDetailsIcon = 'close-circle';
      this.assetsAndLiablitiesIcon = 'close-circle';
      this.realEstateIcon = 'close-circle';
    } else if (event == 'third') {
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "none";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "block";
      var forth = document.getElementById("IncomeDetails");
      forth.style.display = "none";
      var fifth = document.getElementById("assetsAndLiablities");
      fifth.style.display = "none";
      var sixth = document.getElementById("realEstate");
      sixth.style.display = "none";
      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'close-circle';
      this.employmentAndIncomeDetailsIcon = 'checkmark';
      this.incomeDetailsIcon = 'close-circle';
      this.assetsAndLiablitiesIcon = 'close-circle';
      this.realEstateIcon = 'close-circle';
    } else if (event == 'forth') {
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "none";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "none";
      var forth = document.getElementById("IncomeDetails");
      forth.style.display = "block";
      var fifth = document.getElementById("assetsAndLiablities");
      fifth.style.display = "none";
      var sixth = document.getElementById("realEstate");
      sixth.style.display = "none";
      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'close-circle';
      this.employmentAndIncomeDetailsIcon = 'close-circle';
      this.incomeDetailsIcon = 'checkmark';
      this.assetsAndLiablitiesIcon = 'close-circle';
      this.realEstateIcon = 'close-circle';
    } else if (event == 'fifth') {
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "none";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "none";
      var forth = document.getElementById("IncomeDetails");
      forth.style.display = "none";
      var forth = document.getElementById("assetsAndLiablities");
      forth.style.display = "block";
      var fifth = document.getElementById("realEstate");
      fifth.style.display = "none";
      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'close-circle';
      this.employmentAndIncomeDetailsIcon = 'close-circle';
      this.incomeDetailsIcon = 'close-circle';
      this.assetsAndLiablitiesIcon = 'checkmark';
      this.realEstateIcon = 'close-circle';
    }
    else if (event == 'sixth') {
      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "none";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "none";
      var forth = document.getElementById("IncomeDetails");
      forth.style.display = "none";
      var forth = document.getElementById("assetsAndLiablities");
      forth.style.display = "none";
      var fifth = document.getElementById("realEstate");
      fifth.style.display = "block";
      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'close-circle';
      this.employmentAndIncomeDetailsIcon = 'close-circle';
      this.incomeDetailsIcon = 'close-circle';
      this.assetsAndLiablitiesIcon = 'close-circle';
      this.realEstateIcon = 'checkmark';
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.updateValueAndValidity();
      control.markAsDirty();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  clicktest() {

  }


  firstfromnext() {

    debugger;
    window.scrollTo(0, 0);

    this.PrimaryForm.getValue();
    this.AddressDetails.getValue();
    this.PrimaryGoal.getValue();
    let address_data = this.AddressDetails.addreDetail.value;
    this.RealEstateAssets.setaddressvalue(address_data);

     this.markFormGroupTouched(this.primary_form);
     this.markFormGroupTouched(this.primary_goal_form);
     this.markFormGroupTouched(this.address_detail_form);
      console.log(this.AddressDetails.addreDetail);
     if( this.primary_form  && this.primary_goal_form && this.address_detail_form)
    {

        if(this.primary_form.valid && this.primary_goal_form.valid && this.address_detail_form.valid)
        {
          this.step1FormStatusInvalid = false;
         var first = document.getElementById("primaryApplicantDetails");
         first.style.display = "none";
         var second = document.getElementById("dependentAndFamily");
         second.style.display = "block";
         var third = document.getElementById("employmentAndIncomeDetails");
         third.style.display = "none";
         var forth = document.getElementById("IncomeDetails");
         forth.style.display = "none";
         var fifth = document.getElementById("assetsAndLiablities");
         fifth.style.display = "none";
         var sixth = document.getElementById("realEstate");
         sixth.style.display = "none";
         //this.step1FormStatus=true;
        //  if(this.step1FormStatus) {
        //   this.primaryApplicantDetailsIcon = 'checkmark';
        //   this.dependentAndFamilyIcon = 'checkmark';
        //  }
        //  else {
        //   this.primaryApplicantDetailsIcon = 'close-circle';
        //   this.dependentAndFamilyIcon = 'close-circle';
        //  }

          this.checkvalidslide();

        // this.primaryApplicantDetailsIcon = 'close-circle';
        // this.dependentAndFamilyIcon = 'checkmark';

        //  this.employmentAndIncomeDetailsIcon = 'close-circle';
        //  this.incomeDetailsIcon = 'close-circle';
        //  this.assetsAndLiablitiesIcon = 'close-circle';
        //  this.realEstateIcon = 'close-circle';
        } else {
          this.step1FormStatusInvalid = true;
        }

    }

     if(!this.address_detail_form.valid)
     {

       (<FormArray>this.primary_form.controls['addAnotherApplicantItem']).controls.forEach((element,index)=>{
        const isvalid=(<FormArray>this.address_detail_form.controls['addAddressRelationshipItem']).controls[index].valid;

        if(!isvalid)
        {
          this.AddressDetails.showApplicant(index);
        }
       })
     }

     if((<FormArray>this.address_detail_form.controls['addAddressRelationshipItem']).valid){
      if(!this.address_detail_form.valid)
      {

       this.AddressDetails.showprimaryApplicantAddress();

      }
    }

  }
  secondfromprevious() {
    var first = document.getElementById("primaryApplicantDetails");
    first.style.display = "block";
    var second = document.getElementById("dependentAndFamily");
    second.style.display = "none";
    var third = document.getElementById("employmentAndIncomeDetails");
    third.style.display = "none";
    var forth = document.getElementById("IncomeDetails");
    forth.style.display = "none";
    var fifth = document.getElementById("assetsAndLiablities");
    fifth.style.display = "none";
    var sixth = document.getElementById("realEstate");
    sixth.style.display = "none";
    this.checkvalidslide();
    // this.primaryApplicantDetailsIcon = 'checkmark';
    // this.dependentAndFamilyIcon = 'close-circle';
    // this.employmentAndIncomeDetailsIcon = 'close-circle';
    // this.incomeDetailsIcon = 'close-circle';
    // this.assetsAndLiablitiesIcon = 'close-circle';
    // this.realEstateIcon = 'close-circle';
  }


  secondfromnext() {

    window.scrollTo(0, 0);
    this.PrimaryForm.getValue();
    this.AddressDetails.getValue();
    this.PrimaryGoal.getValue();

    this.markFormGroupTouched(this.primary_form);
    this.markFormGroupTouched(this.primary_goal_form);
    this.markFormGroupTouched(this.address_detail_form);


    this.DependentDetails.getValue();

    this.markFormGroupTouched(this.dependent_detail_form);

    console.log('****',this.dependent_detail_form);
    console.log('primary_form=',this.primary_form.valid);
    console.log('primary_goal_form=',this.primary_goal_form.valid );
    console.log('address_detail_form=',this.address_detail_form.valid );
    console.log('dependent_detail_form=',this.dependent_detail_form.valid);

    console.log(this.dependent_detail_form);

    if(this.primary_form
      && this.primary_goal_form
      && this.address_detail_form
      && this.dependent_detail_form
      )
    {

      if(this.primary_form.valid
        && this.primary_goal_form.valid
        && this.address_detail_form.valid
        && this.dependent_detail_form.valid)
        {
          this.step2FormStatusInvalid = false;
          var first = document.getElementById("primaryApplicantDetails");
          first.style.display = "none";
          var second = document.getElementById("dependentAndFamily");
          second.style.display = "none";
          var third = document.getElementById("employmentAndIncomeDetails");
          third.style.display = "block";
          var forth = document.getElementById("IncomeDetails");
          forth.style.display = "none";
          var fifth = document.getElementById("assetsAndLiablities");
          fifth.style.display = "none";
          var sixth = document.getElementById("realEstate");
          sixth.style.display = "none";
          this.checkvalidslide();
          // this.primaryApplicantDetailsIcon = 'close-circle';
          // this.dependentAndFamilyIcon = 'close-circle';
          // this.employmentAndIncomeDetailsIcon = 'checkmark';
          // this.incomeDetailsIcon = 'close-circle';
          // this.assetsAndLiablitiesIcon = 'close-circle';
          // this.realEstateIcon = 'close-circle';
        } else {
          this.step2FormStatusInvalid = true;
        }
    }

    if(!this.dependent_detail_form.valid)
    {
      (<FormArray>this.primary_form.controls['addAnotherApplicantItem']).controls.forEach((element,index)=>{
       const isvalid=(<FormArray>this.dependent_detail_form.controls['addFamilyItem']).controls[index].valid;
       if(!isvalid)
       {
         this.DependentDetails.familyOfApplicant2(index);
       }
      })
    }

    if((<FormArray>this.dependent_detail_form.controls['addFamilyItem']).valid){
      if(!this.dependent_detail_form.valid)
      {

      this.DependentDetails.editprimaryApplicantFamily();

      }
    }
  }

  thirdfromprevious() {
    var first = document.getElementById("primaryApplicantDetails");
    first.style.display = "none";
    var second = document.getElementById("dependentAndFamily");
    second.style.display = "block";
    var third = document.getElementById("employmentAndIncomeDetails");
    third.style.display = "none";
    var forth = document.getElementById("IncomeDetails");
      forth.style.display = "none";
    var fifth = document.getElementById("assetsAndLiablities");
    fifth.style.display = "none";
    var sixth = document.getElementById("realEstate");
    sixth.style.display = "none";
    this.checkvalidslide();
    // this.primaryApplicantDetailsIcon = 'close-circle';
    // this.dependentAndFamilyIcon = 'checkmark';
    // this.employmentAndIncomeDetailsIcon = 'close-circle';
    // this.incomeDetailsIcon = 'close-circle';
    // this.assetsAndLiablitiesIcon = 'close-circle';
    // this.realEstateIcon = 'close-circle';
  }

  thirdfromnext() {

    window.scrollTo(0, 0);
    this.PrimaryForm.getValue();
    this.AddressDetails.getValue();
    this.PrimaryGoal.getValue();
    this.DependentDetails.getValue();
    this.markFormGroupTouched(this.dependent_detail_form);
    this.markFormGroupTouched(this.primary_form);
    this.markFormGroupTouched(this.primary_goal_form);
    this.markFormGroupTouched(this.address_detail_form);

    this.EmploymentDetails.getValue();
    this.IncomeDetails.getValue();



    this.markFormGroupTouched(this.employment_details);
    this.markFormGroupTouched(this.income_details_form);

    this.AssetsForm.getValue();
    this.LiablitiesForm.getValue();


    // this.markFormGroupTouched(this.assert_form);
    // this.markFormGroupTouched(this.liability_form);

    console.log(this.employment_details);

    if(this.primary_form
      && this.primary_goal_form
      && this.address_detail_form
      && this.dependent_detail_form
      && this.employment_details){

        if(this.primary_form.valid
          && this.primary_goal_form.valid
          && this.address_detail_form.valid
          && this.dependent_detail_form.valid
          && this.employment_details.valid){
            this.step3FormStatusInvalid = false;
          var first = document.getElementById("primaryApplicantDetails");
          first.style.display = "none";
          var second = document.getElementById("dependentAndFamily");
          second.style.display = "none";
          var third = document.getElementById("employmentAndIncomeDetails");
          third.style.display = "none";
          var forth = document.getElementById("IncomeDetails");
          forth.style.display = "block";
          var forth = document.getElementById("assetsAndLiablities");
          forth.style.display = "none";
          var fifth = document.getElementById("realEstate");
          fifth.style.display = "none";
          this.checkvalidslide();
          // this.primaryApplicantDetailsIcon = 'close-circle';
          // this.dependentAndFamilyIcon = 'close-circle';
          // this.employmentAndIncomeDetailsIcon = 'close-circle';
          // this.incomeDetailsIcon = 'checkmark';
          // this.assetsAndLiablitiesIcon = 'close-circle';
          // this.realEstateIcon = 'close-circle';
        } else {
          this.step3FormStatusInvalid = true;
        }

      }


      if(!this.employment_details.valid)
      {

        (<FormArray>this.primary_form.controls['addAnotherApplicantItem']).controls.forEach((element,index)=>{
         const isvalid=(<FormArray>this.employment_details.controls['addEmploymentItem']).controls[index].valid;

         if(!isvalid)
         {

           this.EmploymentDetails.employementOfApplicant2(index);
         }
        })
      }

      if((<FormArray>this.employment_details.controls['addEmploymentItem']).valid){
        if(!this.employment_details.valid)
        {

        this.EmploymentDetails.editprimaryApplicantEmployement();

        }
      }


  }

  forthfromprevious() {
    var first = document.getElementById("primaryApplicantDetails");
    first.style.display = "none";
    var second = document.getElementById("dependentAndFamily");
    second.style.display = "none";
    var third = document.getElementById("employmentAndIncomeDetails");
    third.style.display = "block";
    var forth = document.getElementById("IncomeDetails");
      forth.style.display = "none";
    var forth = document.getElementById("assetsAndLiablities");
    forth.style.display = "none";
    var sixth = document.getElementById("realEstate");
    sixth.style.display = "none";
    this.checkvalidslide();
    // this.primaryApplicantDetailsIcon = 'close-circle';
    // this.dependentAndFamilyIcon = 'close-circle';
    // this.employmentAndIncomeDetailsIcon = 'checkmark';
    // this.incomeDetailsIcon = 'close-circle';
    // this.assetsAndLiablitiesIcon = 'close-circle';
    // this.realEstateIcon = 'close-circle';
  }

  forthfromnext() {

    this.PrimaryForm.getValue();
    this.AddressDetails.getValue();
    this.PrimaryGoal.getValue();
    this.DependentDetails.getValue();
    this.markFormGroupTouched(this.dependent_detail_form);
    this.markFormGroupTouched(this.primary_form);
    this.markFormGroupTouched(this.primary_goal_form);
    this.markFormGroupTouched(this.address_detail_form);

    this.EmploymentDetails.getValue();
    this.IncomeDetails.getValue();



    this.markFormGroupTouched(this.employment_details);
    this.markFormGroupTouched(this.income_details_form);

    console.log(this.income_details_form);
    this.AssetsForm.getValue();
    this.LiablitiesForm.getValue();


    // this.markFormGroupTouched(this.assert_form);
    // this.markFormGroupTouched(this.liability_form);


    if(this.primary_form
      && this.primary_goal_form
       && this.address_detail_form
       && this.dependent_detail_form
        && this.employment_details
        && this.income_details_form) {

          if(this.primary_form.valid
            && this.primary_goal_form.valid
             && this.address_detail_form.valid
             && this.dependent_detail_form.valid
              && this.employment_details.valid
              && this.income_details_form.valid)
          {
            this.step4FormStatusInvalid = false;
            var first = document.getElementById("primaryApplicantDetails");
            first.style.display = "none";
            var second = document.getElementById("dependentAndFamily");
            second.style.display = "none";
            var third = document.getElementById("employmentAndIncomeDetails");
            third.style.display = "none";
            var forth = document.getElementById("IncomeDetails");
            forth.style.display = "none";
            var fifth = document.getElementById("assetsAndLiablities");
            fifth.style.display = "block";
            var sixth = document.getElementById("realEstate");
            sixth.style.display = "none";
            this.checkvalidslide();
            // this.primaryApplicantDetailsIcon = 'close-circle';
            // this.dependentAndFamilyIcon = 'close-circle';
            // this.employmentAndIncomeDetailsIcon = 'close-circle';
            // this.incomeDetailsIcon = 'close-circle';
            // this.assetsAndLiablitiesIcon = 'checkmark';
            // this.realEstateIcon = 'close-circle';
          } else {
            this.step4FormStatusInvalid = true;
          }

        }
  }

  fifthfromprevious() {
    var first = document.getElementById("primaryApplicantDetails");
    first.style.display = "none";
    var second = document.getElementById("dependentAndFamily");
    second.style.display = "none";
    var third = document.getElementById("employmentAndIncomeDetails");
    third.style.display = "none";
    var forth = document.getElementById("IncomeDetails");
    forth.style.display = "block";
    var forth = document.getElementById("assetsAndLiablities");
    forth.style.display = "none";
    var fifth = document.getElementById("realEstate");
    fifth.style.display = "none";
    this.checkvalidslide();
    // this.primaryApplicantDetailsIcon = 'close-circle';
    // this.dependentAndFamilyIcon = 'close-circle';
    // this.employmentAndIncomeDetailsIcon = 'close-circle';
    // this.incomeDetailsIcon = 'checkmark';
    // this.assetsAndLiablitiesIcon = 'close-circle';
    // this.realEstateIcon = 'close-circle';
  }

  fifthfromnext() {

  this.PrimaryForm.getValue();
    this.AddressDetails.getValue();
    this.PrimaryGoal.getValue();
    this.DependentDetails.getValue();
    this.markFormGroupTouched(this.dependent_detail_form);
    this.markFormGroupTouched(this.primary_form);
    this.markFormGroupTouched(this.primary_goal_form);
    this.markFormGroupTouched(this.address_detail_form);

    this.EmploymentDetails.getValue();
    this.IncomeDetails.getValue();



    this.markFormGroupTouched(this.employment_details);
    this.markFormGroupTouched(this.income_details_form);



    this.AssetsForm.getValue();
    this.LiablitiesForm.getValue();


    this.markFormGroupTouched(this.assert_form);
    this.markFormGroupTouched(this.liability_form);



    if(this.primary_form
      && this.primary_goal_form
      && this.address_detail_form
      && this.dependent_detail_form
      && this.employment_details
      && this.income_details_form
      && this.assert_form
      && this.liability_form
      && this.isValidPercentage
      ) {
        if(this.primary_form.valid
          && this.primary_goal_form.valid
          && this.address_detail_form.valid
          && this.dependent_detail_form.valid
          && this.employment_details.valid
          && this.income_details_form.valid
          && this.assert_form.valid
          && this.liability_form.valid
          && this.isValidPercentage
          )
        {
          this.step5FormStatusInvalid = false;
          if(this.checkBalanceBool || this.checkBalanceBool == undefined) {

            var first = document.getElementById("primaryApplicantDetails");
            first.style.display = "none";
            var second = document.getElementById("dependentAndFamily");
            second.style.display = "none";
            var third = document.getElementById("employmentAndIncomeDetails");
            third.style.display = "none";
            var forth = document.getElementById("IncomeDetails");
            forth.style.display = "none";
            var fifth = document.getElementById("assetsAndLiablities");
            fifth.style.display = "none";
            var sixth = document.getElementById("realEstate");
            sixth.style.display = "block";
            this.checkvalidslide();
            // this.primaryApplicantDetailsIcon = 'close-circle';
            // this.dependentAndFamilyIcon = 'close-circle';
            // this.employmentAndIncomeDetailsIcon = 'close-circle';
            // this.incomeDetailsIcon = 'close-circle';
            // this.assetsAndLiablitiesIcon = 'close-circle';
            // this.realEstateIcon = 'checkmark';

          }
        } else {
          this.step5FormStatusInvalid = true;
        }

      }
  }

  sixthfromprevious() {
    var first = document.getElementById("primaryApplicantDetails");
    first.style.display = "none";
    var second = document.getElementById("dependentAndFamily");
    second.style.display = "none";
    var third = document.getElementById("employmentAndIncomeDetails");
    third.style.display = "none";
    var forth = document.getElementById("IncomeDetails");
    forth.style.display = "none";
    var forth = document.getElementById("assetsAndLiablities");
    forth.style.display = "block";
    var fifth = document.getElementById("realEstate");
    fifth.style.display = "none";
    this.checkvalidslide();
    // this.primaryApplicantDetailsIcon = 'close-circle';
    // this.dependentAndFamilyIcon = 'close-circle';
    // this.employmentAndIncomeDetailsIcon = 'close-circle';
    // this.incomeDetailsIcon = 'close-circle';
    // this.assetsAndLiablitiesIcon = 'checkmark';
    // this.realEstateIcon = 'close-circle';
  }

  checkvalidslide(){

    console.log('within check validation');
    console.log(this.EmploymentDetails.slideThreeForm.valid);
    console.log(this.EmploymentDetails.slideThreeForm);
    if(this.PrimaryForm.primaryForm.valid && this.PrimaryGoal.primaryGoal.valid && this.AddressDetail.addreDetail.valid)
    {
      this.step1FormStatus = true;
      this.primaryApplicantDetailsIcon = 'checkmark';

    }
    else {
      this.step1FormStatus = false;
      this.primaryApplicantDetailsIcon = 'close-circle';
    }


    if(this.DependentDetails.slideTwoForm.valid)
    {
      this.step2FormStatus = true;
      this.dependentAndFamilyIcon = 'checkmark';

    }
    else {
      this.step2FormStatus = false;
      this.dependentAndFamilyIcon = 'close-circle';
    }
    if(this.EmploymentDetails.slideThreeForm.valid)
    {
      this.step3FormStatus = true;
      this.employmentAndIncomeDetailsIcon = 'checkmark';

    }
    else {
      this.step3FormStatus = false;
      this.employmentAndIncomeDetailsIcon = 'close-circle';
    }
    if(
      this.PrimaryForm.primaryForm.valid
      && this.PrimaryGoal.primaryGoal.valid
      && this.AddressDetail.addreDetail.valid
      && this.DependentDetails.slideTwoForm.valid
      && this.EmploymentDetails.slideThreeForm.valid
      && this.IncomeDetails.incomeForm.valid
      )
    {
      this.step4FormStatus = true;
      this.incomeDetailsIcon = 'checkmark';

    }
    else {
      this.step4FormStatus = false;
      this.incomeDetailsIcon = 'close-circle';
    }
    if(
      this.PrimaryForm.primaryForm.valid
      && this.PrimaryGoal.primaryGoal.valid
      && this.AddressDetail.addreDetail.valid
      && this.DependentDetails.slideTwoForm.valid
      && this.EmploymentDetails.slideThreeForm.valid
      && this.IncomeDetails.incomeForm.valid
      && this.AssetsForm.assetsForm.valid
      && this.LiablitiesForm.liabilitiesForm.valid
      )
    {
      this.step5FormStatus = true;
      this.assetsAndLiablitiesIcon = 'checkmark';

    }
    else {
      this.step5FormStatus = false;
      this.assetsAndLiablitiesIcon = 'close-circle';
    }
    if(
      this.PrimaryForm.primaryForm.valid
      && this.PrimaryGoal.primaryGoal.valid
      && this.AddressDetail.addreDetail.valid
      && this.DependentDetails.slideTwoForm.valid
      && this.EmploymentDetails.slideThreeForm.valid
      && this.IncomeDetails.incomeForm.valid
      && this.AssetsForm.assetsForm.valid
      && this.LiablitiesForm.liabilitiesForm.valid
      && this.RealEstateAssets.realEstateForm.valid
      )
    {
      this.step6FormStatus = true;
      this.realEstateIcon = 'checkmark';

    }
    else {
      this.step6FormStatus = false;
      this.realEstateIcon = 'close-circle';
    }

  }

  editPrimaryApplicantDetails(userdata) {

  }


  getContactdData(thiss) {
    if (thiss.SDF_form_document_id != undefined) {


    }


  }

  editAdditionalApplicantDetails(data) {

    this.additionalContact = data;
    this.additional_Contact_load = true;
  }



  editgetSDFUser(SDF_form_document_id, uid) {
    if (this.userRole == "super_admin" && this.deleted_access == 1) {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).orderBy('created_date', 'asc')).valueChanges();
    } else {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
    }
  }

  primarydetails(index) {

    this.isValidPrimaryForm=index.primaryFormValid;
    this.primaryformget=index.primaryFormValue;
    this.primary_form=index.primaryForm;


    if (index == 0 || index == 1 || index == 2 || index == 3 || index == 4 || index == 5 || index == 5 || index == 7) {
      this.del(index);
      return;
    }

    if (index.primaryFormValid != true) {
      this.primaryformget = index.primaryFormValue;

    }


  }

  del(index) {

    this.AddressDetail.deleteSecondaryApplicant(index);
    this.DependentDetails.deleteSecondaryApplicant(index);
    this.EmploymentDetails.deleteSecondaryApplicant(index)
    this.IncomeDetails.deleteSecondaryApplicant(index);
  }

  primarydetailsGet(count) {

    if (count != true) {


      var first = document.getElementById("primaryApplicantDetails");
      first.style.display = "none";
      var second = document.getElementById("dependentAndFamily");
      second.style.display = "block";
      var third = document.getElementById("employmentAndIncomeDetails");
      third.style.display = "none";
      var forth = document.getElementById("assetsAndLiablities");
      forth.style.display = "none";
      var fifth = document.getElementById("realEstate");
      fifth.style.display = "none";
      this.primaryApplicantDetailsIcon = 'close-circle';
      this.dependentAndFamilyIcon = 'checkmark';
      this.employmentAndIncomeDetailsIcon = 'close-circle';
      this.assetsAndLiablitiesIcon = 'close-circle';
      this.realEstateIcon = 'close-circle';
    }

  }

  dependentdetails(count) {

    this.isValidDependentDetialsForm=count.dependentDetailFormIsValid;
    this.dependentformget = count.dependentDetailFormValue;
    this.dependent_detail_form=count.dependentdetailform;

  }

  employmentdetails(count) {

    debugger;
      this.employmentformget = count.emplomentDetailFormValue;

      this.employment_details=count.employementdetailform;
      var format = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;

      if(format.test(count)){
        console.log(this.IncomeDetails);
        this.IncomeDetails.getRoleStartDate(count);
      } else {

      this.employmentformget = count.emplomentDetailFormValue;
      this.isValidEmplomentDeatilForm=count.emplomentDetailFormIsValid;
      }


  }


  incomedetails(count) {

    this.incomeformget = count.incomeDetailFormValue;
    this.income_details_form=count.incomedetailsform;


      let address_form_value = this.AddressDetails.addreDetail.value;

      this.AssetsForm.setAssetform(this.primaryformget);
      this.LiablitiesForm.setLiabilitiesform(this.primaryformget);
      this.RealEstateAssets.setrealEstateForm(this.primaryformget,address_form_value);

  }

  getAddressFormData(addressFormVal){



      this.addressFormValue=addressFormVal.addressDetailFormValue;
      this.isValidAddressForm=addressFormVal.addressDetailFormValid;
      this.address_detail_form=addressFormVal.addressDetailForm;

  }

  getPrimaryGoalFormData(primaryGoalFormVal){


    this.isValidPrimaryGoalForm=primaryGoalFormVal.primaryGoalFormValid;

    this.isValidPrimaryGoalForm=primaryGoalFormVal.primaryGoalFormValid;

    this.primaryGoalFormValue=primaryGoalFormVal.primaryGoalFormValue;

    this.primary_goal_form=primaryGoalFormVal.primarygoalform;

  }

  getAssetsFormData(assetsFormVal){
    this.assetsFormValue=assetsFormVal.assertformvalue;
    this.assert_form=assetsFormVal.assertform;

  }

  getLiabilityFormData(liabilityFormVal){
    this.liabilityFormValue=liabilityFormVal.liabilityformvalue;
    this.liability_form=liabilityFormVal.liabilitiesform;

  }

  onHandleSubmit()
  {
    this.RealEstateAssets.getValue();
    console.log(this.realestate_form);
    
    this.markFormGroupTouched(this.realestate_form);
    this.loadingProvider.startLoading();



    console.log('real estate form=',this.realestate_form);


    this.adfModuleAllFormData['primary_contact_id']=this.primary_contact_id;


    this.adfModuleAllFormData['primaryFormValue']=this.primaryformget;
    this.adfModuleAllFormData['primaryGoalFormValue']=this.primaryGoalFormValue;
    this.adfModuleAllFormData['addressFormValue']=this.addressFormValue;


    this.adfModuleAllFormData['dependentAndFamilyFormValue']=this.dependentformget;


    this.adfModuleAllFormData['employmentDetailFormValue']=this.employmentformget;
    this.adfModuleAllFormData['incomeDetailFormValue']=this.incomeformget;


    this.adfModuleAllFormData['assertsFormValue']=this.assetsFormValue;
    this.adfModuleAllFormData['liabilityFormValue']=this.liabilityFormValue;


    this.adfModuleAllFormData['realEstateFormValue']=this.realEstateFormValue;

    this.PrimaryForm.getUserAndBrokerId();

    this.adfModuleAllFormData['adf_form_id']=this.adfFormAllIdForSubmit.adf_form_id;
    this.adfModuleAllFormData['primary_contact_id']=this.adfFormAllIdForSubmit.primary_contact_id;
    this.adfModuleAllFormData['reference_broker']=this.adfFormAllIdForSubmit.reference_broker;

    console.log("***********",this.adfModuleAllFormData);
    if(this.realestate_form.valid)
    {
      this.step6FormStatusInvalid = false;
      this.ADFFormService.saveADFForm(this.adfModuleAllFormData).then((data:any)=>{
        this.loadingProvider.stopLoading();
        if(data.status=="success"){
          this.presentToast("AFD form created successfully..");

          this.navCtrl.pop();

          if(this.userRole == 'contact') {

            this.navCtrl.push(ShowContactForm);
          }
          else {

            this.navCtrl.push(ViewAdfPage,{
              contact_uid:data.primary_contact_id,
              SDF_form_document_id:data.adf_id
            });
          }


        }

    })
    }
    else{
      this.step6FormStatusInvalid = true;
      this.loadingProvider.stopLoading();
    }

  }

  presentToastPartial(){
    if(this.edit_flag === 'edit'){
      this.presentToast("Partial AFD form updated successfully..");
    } else {
      this.presentToast("Partial AFD form saved successfully..");
    }
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  getRealEstateFormData(realEstateFormVal)
  {

    this.realEstateFormValue=realEstateFormVal.realEstateFormData;
    this.realEstateFormIsValid=realEstateFormVal.formStatus;
    this.realestate_form=realEstateFormVal.realestateform;
    console.log(this.realestate_form);
    
  }

  getUserAndBrokerId(valObj)
  {
    this.adfFormAllIdForSubmit=valObj;
  }

  getRoleStartDate(date){

  }

  getEmployementDetailData(employemnetDetailData){
    this.EmploymentDetails.getEmployementDetail(employemnetDetailData);
  }
  primaryformDetailData(primaryDetailData){

    this.AddressDetail.setAddressDetail(primaryDetailData);
    this.DependentDetails.setDependentDetails(primaryDetailData);
    this.EmploymentDetails.setEmploymentDetails(primaryDetailData);
    this.IncomeDetails.setIncomeDetails(primaryDetailData);

  }
  additionalformDetailData(additionalDetailData) {

     this.AddressDetail.setAddiAddressDetail(additionalDetailData);
    this.DependentDetails.setAddiDependentDetails(additionalDetailData);
     this.EmploymentDetails.setAddiEmploymentDetails(additionalDetailData);
     this.IncomeDetails.setAddiIncomeDetails(additionalDetailData);
  }
  deleteApplicantData(deleteIndex) {

    this.AddressDetail.setApplicantDetail(deleteIndex);

  }

  getDateCommence(obj){

    this.IncomeDetails.getDateCommence(obj);

  }

  getVal(obj){

    this.isValidPercentage=obj.isValid;

  }

  getFullAdfFormValueForPartialSubmit()
  {
    this.PrimaryForm.getValue();
    this.AddressDetails.getValue();
    this.PrimaryGoal.getValue();

    this.DependentDetails.getValue();

    this.EmploymentDetails.getValue();
    this.IncomeDetails.getValue();

    this.AssetsForm.getValue();
    this.LiablitiesForm.getValue();

    this.RealEstateAssets.getValue();



    this.adfModuleAllFormData['primaryFormValue']=this.primaryformget;
    this.adfModuleAllFormData['primaryGoalFormValue']=this.primaryGoalFormValue;
    this.adfModuleAllFormData['addressFormValue']=this.addressFormValue;


    this.adfModuleAllFormData['dependentAndFamilyFormValue']=this.dependentformget;


    this.adfModuleAllFormData['employmentDetailFormValue']=this.employmentformget;
    this.adfModuleAllFormData['incomeDetailFormValue']=this.incomeformget;


    this.adfModuleAllFormData['assertsFormValue']=this.assetsFormValue;
    this.adfModuleAllFormData['liabilityFormValue']=this.liabilityFormValue;


    this.adfModuleAllFormData['realEstateFormValue']=this.realEstateFormValue;

    this.PrimaryForm.getUserAndBrokerId();

    this.adfModuleAllFormData['adf_form_id']=this.adfFormAllIdForSubmit.adf_form_id;
    this.adfModuleAllFormData['primary_contact_id']=this.adfFormAllIdForSubmit.primary_contact_id;
    this.adfModuleAllFormData['reference_broker']=this.adfFormAllIdForSubmit.reference_broker;



  }

  onHandleFirstPagePartialSubmit(){


    this.getFullAdfFormValueForPartialSubmit();



    this.markFormGroupTouched(this.primary_form);
    this.markFormGroupTouched(this.primary_goal_form);
    this.markFormGroupTouched(this.address_detail_form);



    if(this.primary_form.valid && this.primary_goal_form.valid && this.address_detail_form.valid)
    {
      this.step1FormStatusInvalid = false;
     this.loadingProvider.startLoading();
      this.ADFFormService.saveADFForm(this.adfModuleAllFormData).then((data:any)=>{
        if(data.status=="success"){
          console.log(data);
          
          this.loadingProvider.stopLoading();
          this.presentToastPartial();
          this.goToAdfPage(data.primary_contact_id, data.adf_id);
        }
    });

    }
    else
    {
      this.step1FormStatusInvalid = true;
    }

  }

  onHandleSecondPagePartialSubmit(){



    this.getFullAdfFormValueForPartialSubmit();

    this.markFormGroupTouched(this.dependent_detail_form);

    if(this.dependent_detail_form.valid)
    {
      this.step2FormStatusInvalid = false;
      this.loadingProvider.startLoading();
      this.ADFFormService.saveADFForm(this.adfModuleAllFormData).then((data:any)=>{
        if(data.status=="success"){
          this.loadingProvider.stopLoading();
          this.presentToastPartial();
          this.goToAdfPage(data.primary_contact_id, data.adf_id);
        }
    });
    } else {
      this.step2FormStatusInvalid = true;
    }
  }

  onHandleThirdPagePartialSubmit()
  {
    this.getFullAdfFormValueForPartialSubmit();

    this.markFormGroupTouched(this.employment_details);
    this.markFormGroupTouched(this.income_details_form);

    if(this.employment_details.valid)
    {
      this.step3FormStatusInvalid = false;
      this.loadingProvider.startLoading();
      this.ADFFormService.saveADFForm(this.adfModuleAllFormData).then((data:any)=>{
        if(data.status=="success"){
          this.loadingProvider.stopLoading();
          this.presentToastPartial();
          this.goToAdfPage(data.primary_contact_id, data.adf_id);
        }
    });
    } else {
      this.step3FormStatusInvalid = true;
    }
  }
  
  onHandleFourthPagePartialSubmit()
  {
    this.getFullAdfFormValueForPartialSubmit();

    this.markFormGroupTouched(this.employment_details);
    this.markFormGroupTouched(this.income_details_form);

    if(this.income_details_form.valid)
    {
      this.step4FormStatusInvalid = false;
      this.loadingProvider.startLoading();
      this.ADFFormService.saveADFForm(this.adfModuleAllFormData).then((data:any)=>{
        if(data.status=="success"){
          this.loadingProvider.stopLoading();
          this.presentToastPartial();
          this.goToAdfPage(data.primary_contact_id, data.adf_id);
        }
    });
    } else {
      this.step4FormStatusInvalid = true;
    }
  }

  onHandleFifthPagePartialSubmit()
  {
    this.getFullAdfFormValueForPartialSubmit();

    this.markFormGroupTouched(this.assert_form);
    this.markFormGroupTouched(this.liability_form);

    if(this.assert_form.valid && this.liability_form.valid && this.isValidPercentage)
    {
      this.step5FormStatusInvalid = false;
      this.loadingProvider.startLoading();
      this.ADFFormService.saveADFForm(this.adfModuleAllFormData).then((data:any)=>{
        if(data.status=="success"){
          this.loadingProvider.stopLoading();
          this.presentToastPartial();
          this.goToAdfPage(data.primary_contact_id, data.adf_id);
        }
    });
    } else {
      this.step5FormStatusInvalid = true;
    }
  }

  goToAdfPage(userId, formId){
    this.navCtrl.pop();
    if(this.userRole == 'contact') {
      this.navCtrl.push(ShowContactForm);
    }
    else {
      console.log('go to view adf page',userId, formId);
      
      this.navCtrl.push(ViewAdfPage,{
        contact_uid: userId,
        SDF_form_document_id: formId
      });

    }

  }

  exit()
  {
    this.navCtrl.push(AdfList);
  }

  checkBalance(bool){

    this.checkBalanceBool=bool;
  }

  emitOne(){
    debugger;
    console.log('emit one');
    console.log(this.AddressDetails.addreDetail.value.address_format);
    console.log(this.RealEstateAssets.address_details);
    if(this.edit_flag == undefined) {
      if(this.AddressDetails.addreDetail.value) {
        if(this.RealEstateAssets.address_details) {
          this.RealEstateAssets.address_details.address_format = this.AddressDetails.addreDetail.value.address_format;
          this.RealEstateAssets.address_details.floor_number = this.AddressDetails.addreDetail.value.floor_number;
          this.RealEstateAssets.address_details.unit_number = this.AddressDetails.addreDetail.value.unit_number;
          this.RealEstateAssets.address_details.building_name = this.AddressDetails.addreDetail.value.building_name;
          this.RealEstateAssets.address_details.street_number = this.AddressDetails.addreDetail.value.street_number;
          this.RealEstateAssets.address_details.street_name = this.AddressDetails.addreDetail.value.street_name;
          this.RealEstateAssets.address_details.street_type = this.AddressDetails.addreDetail.value.street_type;
          this.RealEstateAssets.address_details.city = this.AddressDetails.addreDetail.value.city;
          this.RealEstateAssets.address_details.state = this.AddressDetails.addreDetail.value.state;
          this.RealEstateAssets.address_details.postcode = this.AddressDetails.addreDetail.value.postcode;
          this.RealEstateAssets.address_details.country = this.AddressDetails.addreDetail.value.country;
        }
        else {
          this.RealEstateAssets.setaddressvalue(this.AddressDetails.addreDetail.value);
        }

        console.log(this.RealEstateAssets.address_details);
      }
    }


    this.RealEstateAssets.demo()
  }

  emitTwo()
  {
    debugger
    console.log('emit one');
    if(this.edit_flag == undefined) {
      if(this.RealEstateAssets.address_details) {
        this.RealEstateAssets.address_details.address_format = this.AddressDetails.addreDetail.value.address_format;
        this.RealEstateAssets.address_details.floor_number = this.AddressDetails.addreDetail.value.floor_number;
        this.RealEstateAssets.address_details.unit_number = this.AddressDetails.addreDetail.value.unit_number;
        this.RealEstateAssets.address_details.building_name = this.AddressDetails.addreDetail.value.building_name;
        this.RealEstateAssets.address_details.street_number = this.AddressDetails.addreDetail.value.street_number;
        this.RealEstateAssets.address_details.street_name = this.AddressDetails.addreDetail.value.street_name;
        this.RealEstateAssets.address_details.street_type = this.AddressDetails.addreDetail.value.street_type;
        this.RealEstateAssets.address_details.city = this.AddressDetails.addreDetail.value.city;
        this.RealEstateAssets.address_details.state = this.AddressDetails.addreDetail.value.state;
        this.RealEstateAssets.address_details.postcode = this.AddressDetails.addreDetail.value.postcode;
        this.RealEstateAssets.address_details.country = this.AddressDetails.addreDetail.value.country;
      }
      else {
        this.RealEstateAssets.setaddressvalue(this.AddressDetails.addreDetail.value);
      }
      // if(this.AddressDetails.addreDetail.value) {
      //   this.RealEstateAssets.address_details.address_format = this.AddressDetails.addreDetail.value.address_format;
      //   this.RealEstateAssets.address_details.floor_number = this.AddressDetails.addreDetail.value.floor_number;
      //   this.RealEstateAssets.address_details.unit_number = this.AddressDetails.addreDetail.value.unit_number;
      //   this.RealEstateAssets.address_details.building_name = this.AddressDetails.addreDetail.value.building_name;
      //   this.RealEstateAssets.address_details.street_number = this.AddressDetails.addreDetail.value.street_number;
      //   this.RealEstateAssets.address_details.street_name = this.AddressDetails.addreDetail.value.street_name;
      //   this.RealEstateAssets.address_details.street_type = this.AddressDetails.addreDetail.value.street_type;
      //   this.RealEstateAssets.address_details.city = this.AddressDetails.addreDetail.value.city;
      //   this.RealEstateAssets.address_details.state = this.AddressDetails.addreDetail.value.state;
      //   this.RealEstateAssets.address_details.postcode = this.AddressDetails.addreDetail.value.postcode;
      //   this.RealEstateAssets.address_details.country = this.AddressDetails.addreDetail.value.country;
      // }
    }



    this.RealEstateAssets.demo2();
  }
  addincome(event) {
    debugger;
    if(this.IncomeDetails) {
      this.IncomeDetails.addeventIncome(event);
    }

  }
  AddincomeDateChane(event) {
    debugger;
    console.log(event);
    //console.log()
    if(this.IncomeDetails) {
      this.IncomeDetails.AddincomeDateChange(event);
    }
  }
  additionincome(event) {
    debugger;
    if(this.IncomeDetails) {
      this.IncomeDetails.additioneventIncome(event);
    }
  }

  changeAdfStatus(event)
  {
    console.log(event);
    if(!event) {
     this.ADFFormService.update_adf_status(this.edit_form_id,event).then(()=>{
       console.log('abc');

       if(this.adfFormStatus) {
        this.navCtrl.pop();
        this.navCtrl.push(AdfList);
       }

     })
    }
    //alert('abc');
  }

}




// WEBPACK FOOTER //
// ./src/pages/adf-page/adf-page.ts